// extracted by mini-css-extract-plugin
module.exports = {"drawer":"drawer_drawer__fEfPH","container":"drawer_container__vRo90","not_available":"drawer_not_available__Tmf5r"};